<ngx-loading-bar color="#00A9E7"></ngx-loading-bar>
